var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonkey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M332.597,500.338c79.231-24.812,141.877-87.102,167.21-166.102L318.579,153.01l-54.924,111.794 l-41.103-41.103l-83.016,29.279l95.266,95.266l-37.964,16.334L332.597,500.338z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC61B"
    },
    cx: 166.064,
    cy: 231.434,
    r: 34.185
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EAA22F"
    },
    cx: 345.936,
    cy: 231.434,
    r: 34.185
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35933"
    },
    d: "M256,390.163L256,390.163c-44.882,0-81.267-36.385-81.267-81.267V204.857 c0-44.882,36.385-81.267,81.267-81.267l0,0c44.882,0,81.267,36.385,81.267,81.267v104.039 C337.267,353.778,300.882,390.163,256,390.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B54324"
    },
    d: "M256,123.59v266.573c44.882,0,81.267-36.385,81.267-81.267V204.857 C337.267,159.975,300.884,123.59,256,123.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M256.579,352.656c0,0,23.847,1.339,42.599-24.871c18.754-26.21-2.01-62.2-0.671-80.955 c1.339-18.754,24.112-41.527-3.35-58.271c-27.462-16.744-38.581,10.047-38.581,10.047s-12.279-26.791-39.739-10.047 s-4.689,39.517-3.35,58.271s-19.423,54.743-0.671,80.955C231.574,353.995,256.579,352.656,256.579,352.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M298.51,246.831c1.339-18.754,24.112-41.525-3.35-58.271c-27.46-16.744-38.581,10.047-38.581,10.047 s-0.191-0.417-0.579-1.114v155.176c0.372-0.002,0.579-0.012,0.579-0.012s23.847,1.339,42.599-24.871 C317.933,301.573,297.17,265.583,298.51,246.831z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#272525"
    },
    cx: 283.152,
    cy: 220.712,
    r: 6.697
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#59595B"
    },
    cx: 228.848,
    cy: 220.712,
    r: 6.697
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#59595B"
    },
    cx: 247.174,
    cy: 272.394,
    r: 4.689
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#272525"
    },
    cx: 264.826,
    cy: 272.394,
    r: 4.689
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C92F00"
    },
    d: "M264.845,310.438c-0.798,0-1.593-0.069-2.384-0.207c-3.063-0.536-5.441-2.015-7.199-3.618 c-4.375,3.134-8.694,4.353-12.893,3.618c-7.397-1.293-10.781-8.076-11.142-8.845c-1.215-2.586-0.105-5.667,2.479-6.88 c2.569-1.212,5.625-0.117,6.858,2.431c0.067,0.128,1.481,2.765,3.625,3.112c2.024,0.34,4.917-1.277,8.154-4.518 c1.191-1.19,2.889-1.726,4.548-1.438c1.66,0.29,3.074,1.371,3.789,2.894l0,0c0.002,0,1.426,2.71,3.601,3.062 c2.038,0.34,4.917-1.277,8.154-4.518c2.017-2.02,5.292-2.02,7.313,0c2.02,2.019,2.02,5.292,0,7.313 C274.703,307.891,269.698,310.436,264.845,310.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#930000"
    },
    d: "M279.749,295.529c-2.02-2.02-5.296-2.02-7.313,0c-3.239,3.241-6.118,4.858-8.154,4.518 c-2.176-0.352-3.6-3.062-3.601-3.062c-0.715-1.524-2.129-2.605-3.789-2.894c-0.296-0.052-0.593-0.047-0.89-0.047v13.167 c1.67,1.357,3.791,2.551,6.461,3.019c0.791,0.138,1.586,0.207,2.384,0.207c4.853-0.002,9.857-2.548,14.905-7.596 C281.769,300.822,281.769,297.548,279.749,295.529z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonkey);
export default __webpack_public_path__ + "static/media/monkey.68a0426d42cee2929a25e9f5187aa22c.svg";
export { ForwardRef as ReactComponent };